import { useEffect } from "react";
import { AlertRequest } from "../../app/types";
import { useRegistration } from "../api/helpers";
import useVenueId from "../common/useVenueId";
import useAlert from "../modals/useAlert";

const redirectToEventPageAlertRequest: AlertRequest = {
  title: "Registration Not Found",
  msg: "Click OK to be redirected to the event homepage",
};

const useRegistrationGate = () => {
  const registrationQuery = useRegistration();
  const venueId = useVenueId();
  const showAlert = useAlert(redirectToEventPageAlertRequest, () => {
    window.location.href = `/Event/${venueId}`;
  });

  useEffect(() => {
    if (registrationQuery.data?.isRegistered === false) {
      showAlert();
    }
  }, [registrationQuery.data?.isRegistered, showAlert]);

  return registrationQuery;
};

export default useRegistrationGate;
